import { combineReducers } from "redux";
import authReducer from './auth';
import settingsReducer from './settings';

const rootReducers = combineReducers({
  auth: authReducer,
  settings: settingsReducer,
});

export type rootReducersState = ReturnType<typeof rootReducers>;
export default rootReducers;
